import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

interface Card {
  title: string;
  text: string;
}

@Component({
  selector: 'app-digital-experience-project',
  templateUrl: './digital-experience-project.component.html',
  styleUrls: ['./digital-experience-project.component.css'],
  standalone: false
})
export class DigitalExperienceProjectComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | Proyecto de Optimización de Experiencia Digital');
  }

  cards: Card[] = [
    {
      title: 'RETO',
      text: 'Plataformas digitales con tráfico existente pero bajo rendimiento en conversión y pérdida de oportunidades en momentos clave del recorrido del usuario.'
    },
    {
      title: 'OBJETIVO',
      text: 'Mejorar la eficiencia de los activos digitales existentes, incrementando su capacidad de generar resultados sin necesidad de aumentar la inversión en adquisición.'
    },
    {
      title: 'SOLUCIÓN',
      text: 'Optimización del recorrido del usuario, análisis de comportamiento digital y ajuste de elementos clave para mejorar la conversión y el rendimiento global del canal.'
    }
  ];

}
